import React from 'react';
import { ListingBlock } from '@/components/ui';
import { CodeBlock } from '../CodeBlock';
import { SectionWrapper } from '../SectionWrapper';

export function ListingBlocksSection() {
  return (
    <SectionWrapper title="Listing Blocks">
        <div>
          <h3 className="text-lg font-semibold mb-4">Standard Listing Blocks</h3>
          <div className="space-y-6">
            {/* Client-style block with meta items */}
            <div className="border border-border rounded-lg p-6 bg-card">
              <h4 className="text-sm font-medium mb-3">Client Listing Style</h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <ListingBlock
                  title="Acme Corporation"
                  subtitle="John Smith"
                  metaItems={[
                    {
                      icon: <span className="w-4 h-4 text-blue-500">📧</span>,
                      label: 'Email',
                      value: 'john@acme.com'
                    },
                    {
                      icon: <span className="w-4 h-4 text-green-500">📞</span>,
                      label: 'Phone',
                      value: '+1 (555) 123-4567'
                    }
                  ]}
                  badge={{
                    label: 'ID: acme-corp',
                    variant: 'secondary'
                  }}
                  actions={[
                    { label: 'Edit', onClick: () => {} },
                    { label: 'Delete', onClick: () => {} }
                  ]}
                  onClick={() => {}}
                />
              </div>
            </div>

            {/* Event-style block with description */}
            <div className="border border-border rounded-lg p-6 bg-card">
              <h4 className="text-sm font-medium mb-3">Event Listing Style</h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <ListingBlock
                  title="Annual Conference 2024"
                  subtitle="/annual-conference-2024"
                  description="Our biggest event of the year featuring keynote speakers, workshops, and networking opportunities for industry professionals."
                  badge={{
                    label: 'ID: conf-2024',
                    variant: 'secondary'
                  }}
                  actions={[
                    { label: 'Edit', onClick: () => {} },
                    { label: 'Delete', onClick: () => {} }
                  ]}
                  onClick={() => {}}
                />
              </div>
            </div>

            {/* Minimal block without arrow */}
            <div className="border border-border rounded-lg p-6 bg-card">
              <h4 className="text-sm font-medium mb-3">Non-clickable Block</h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <ListingBlock
                  title="Static Information Block"
                  subtitle="No navigation"
                  description="This block has no onClick handler, so it doesn't show an arrow icon."
                  badge={{
                    label: 'Status: Active',
                    variant: 'success'
                  }}
                  showArrow={false}
                />
              </div>
            </div>
          </div>
          <CodeBlock>
{`// Client listing with meta items and actions
<ListingBlock
  title="Acme Corporation"
  subtitle="John Smith"
  metaItems={[
    {
      icon: <Mail className="w-4 h-4" />,
      label: 'Email',
      value: 'john@acme.com'
    },
    {
      icon: <Phone className="w-4 h-4" />,
      label: 'Phone',
      value: '+1 (555) 123-4567'
    }
  ]}
  badge={{ label: 'ID: acme-corp', variant: 'secondary' }}
  actions={[
    { label: 'Edit', onClick: () => editClient(client) },
    { label: 'Delete', onClick: () => deleteClient(client) }
  ]}
  onClick={() => navigate(\`/clients/\${client.id}\`)}
/>

// Event listing with description
<ListingBlock
  title="Annual Conference 2024"
  subtitle="/annual-conference-2024"
  description="Description text that shows up to 2 lines..."
  badge={{ label: 'ID: conf-2024', variant: 'secondary' }}
  actions={eventActions}
  onClick={() => navigate(\`/events/\${event.id}\`)}
/>

// Key features:
// ✅ Arrow icon properly positioned all the way to the right
// ✅ Responsive layout with proper text truncation
// ✅ Flexible meta items with icons
// ✅ Action buttons with event propagation handling
// ✅ Consistent spacing and typography
// ✅ Badge variants for different statuses`}
          </CodeBlock>
        </div>
    </SectionWrapper>
  );
}
